import { Links } from '../config/links';

const Footer = () => {
  const year = new Date().getFullYear();
  return (
    <footer className="bg-slate-50/90">
      <hr />
      <div className="mx-auto grid w-full max-w-6xl grid-cols-1 gap-8 px-4 py-10 md:grid-cols-2">
        <div className="rounded-2xl p-0 md:col-span-1">
          <p className="text-sm font-semibold text-slate-900">What is FastBar?</p>
          <p className="mt-2 text-sm leading-relaxed text-slate-600">
            FastBar is a modern, cloud‑based Point of Sale and payments platform built for events and venues. We help
            organizers increase revenue, streamline operations, and deliver a better guest experience.
          </p>
          <div className="mt-4">
            <a href={Links.ContactUs} target="_blank" rel="noopener noreferrer" className="btn-primary btn-compact">
              Contact Us
            </a>
          </div>
        </div>

        <div className="flex flex-col items-center gap-2 rounded-2xl p-0 text-center md:items-end md:text-right md:col-span-1">
          <div className="text-sm leading-relaxed text-slate-600">Powered by</div>
          <a href={Links.MainSite} target="_blank" rel="noopener noreferrer" className="inline-flex">
            <img
              src="/fastbar-logo-forwhitebg.svg"
              alt="FastBar"
              className="h-12 w-auto select-none"
            />
          </a>
          <div className="text-sm text-slate-600">© {year} FastBar Technologies, Inc.</div>
          <div className="flex items-center justify-center gap-5 text-sm text-slate-400 md:justify-end">
            <a href={Links.Privacy} target="_blank" rel="noopener noreferrer" className="hover:text-slate-900">
              Privacy
            </a>
            <a href={Links.Terms} target="_blank" rel="noopener noreferrer" className="hover:text-slate-900">
              Terms
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
